import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from '../../hooks/useAuth';

const RequireNoAuth = () => {
  const { authState } = useAuth();
  const location = useLocation();

    if (authState.isAuthenticated) {
      const from = location.state?.from;
      const destination = from?.pathname === "/school-email"
        ? { pathname: "/school-email", hash: from.hash || "" }
        : "/dashboard";
      return <Navigate to={destination} replace />;
    }
    return <Outlet />
}

export default RequireNoAuth
